import { MenuItem, MenuDivider, FocusableItem } from '@szhsin/react-menu';
import { IoIosColorFilter } from 'react-icons/io';
import { MdOutlineFormatColorReset } from 'react-icons/md';
import { standardColors, themeColors } from '../../data/colors';
import './basicColorPicker.scss';
import { Box, Flex, Input } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { getCurrenySymbolFromCode } from '../../../sheet/utils/numberFormat/generalHelpers';
import {
  allCurrencies,
  allCurrenciesList,
  basicCurrencies,
  basicCurrenciesList,
} from '../../data/currencies';
import { debounce, throttle } from 'lodash';

interface ICurrencyPickerPickerProps {
  code: string;
  includeNone?: boolean;
  onSelect: (color: string) => void;
}

const CurrencyPicker: React.FC<ICurrencyPickerPickerProps> = ({
  code,
  includeNone,
  onSelect,
}) => {
  const [searchText, setSearchText] = useState('');
  // #region views
  const debouncedSetSearchText = debounce((value) => setSearchText(value), 10);

  const currencyView = (currencyCode: string, symbol: string, name: string) => {
    const isNone = currencyCode === 'none';
    const isChecked = isNone ? !code.length : code === currencyCode;
    const displayText = symbol.length ? `${symbol} ${name}` : currencyCode;

    return (
      <MenuItem
        key={currencyCode}
        type="checkbox"
        checked={isChecked}
        onClick={() => onSelect(isNone ? '' : currencyCode)}
        style={{
          fontFamily: 'Lato',
          fontSize: '16px',
          textTransform: 'capitalize',
          textAlign: 'left',
        }}
      >
        {displayText}
      </MenuItem>
    );
  };

  const currenciesView = (
    currenciesList: Array<[string, string]>,
    showDivider = false
  ) => {
    let List = currenciesList;

    if (searchText) {
      List = currenciesList.filter((currency) => {
        const code = currency[0];
        const name = currency[1] ?? code;
        // const name = currenciesList[code] ?? code;
        const symbol = getCurrenySymbolFromCode(code);
        return (
          code.toLowerCase().includes(searchText.toLowerCase()) ||
          name.toLowerCase().includes(searchText.toLowerCase()) ||
          symbol === searchText
        );
      });
    }

    const filteredList = List.map((currency) => {
      const code = currency[0];
      const name = currency[1] ?? code;
      const symbol = getCurrenySymbolFromCode(code);
      // let name = currenciesList[code] ?? code;

      return currencyView(code, symbol, name);
    });

    if (showDivider) filteredList.unshift(<MenuDivider key="divider" />);

    return filteredList;
  };

  const searchBox = () => (
    <FocusableItem>
      {({ ref }) => (
        <Input
          ref={ref}
          type="search"
          placeholder="Search"
          size="sm"
          variant="outline"
          value={searchText}
          onChange={(e) => debouncedSetSearchText(e.target.value)}
          autoFocus={true}
          onKeyDown={(e) => {
            if (e.key === 'Backspace') {
              ref.current.focus();
            }
          }}
          width="100%"
        />
      )}
    </FocusableItem>
  );

  const basicList = currenciesView(basicCurrenciesList);

  // #endregion views
  return (
    <Box style={styles.container}>
      {/* {searchBox()} */}
      {includeNone && currenciesView([['none', '']])}
      {basicList}
      {currenciesView(allCurrenciesList, !!(basicList.length && includeNone))}
    </Box>
  );
};

const styles = {
  container: {
    maxWidth: '280px',
    minWidth: '280px',
    fontSize: '18px',
    fontFamily: 'Lato',
  } as React.CSSProperties,
};

export default CurrencyPicker;
